var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4363 0.825437C13.8702 0.391521 14.5738 0.391521 15.0077 0.825437L18.341 4.15877C18.7749 4.59269 18.7749 5.2962 18.341 5.73012C17.9071 6.16403 17.2036 6.16403 16.7697 5.73012L15.3331 4.29357V12.7222C15.3331 13.3359 14.8357 13.8333 14.222 13.8333C13.6084 13.8333 13.1109 13.3359 13.1109 12.7222V4.29357L11.6743 5.73012C11.2404 6.16403 10.5369 6.16403 10.103 5.73012C9.66908 5.2962 9.66908 4.59269 10.103 4.15877L13.4363 0.825437ZM5.33312 7.16667C5.94677 7.16667 6.44423 7.66413 6.44423 8.27778V16.7064L7.88078 15.2699C8.31469 14.836 9.01821 14.836 9.45212 15.2699C9.88604 15.7038 9.88604 16.4073 9.45212 16.8412L6.11879 20.1746C5.68488 20.6085 4.98136 20.6085 4.54744 20.1746L1.21411 16.8412C0.780193 16.4073 0.780193 15.7038 1.21411 15.2699C1.64802 14.836 2.35154 14.836 2.78546 15.2699L4.22201 16.7064V8.27778C4.22201 7.66413 4.71947 7.16667 5.33312 7.16667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrows);
export default __webpack_public_path__ + "static/media/SortArrows.7d35c508a0ed2d38a344b614779c0d8c.svg";
export { ForwardRef as ReactComponent };